import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import SingleDocument from "./SingleDocument";

const LegalRepresentativeProof = (props) => (
  <SingleDocument
    {...props}
    formKey={SUBSCRIPTION_FORM_KEYS.PROOF.LEGAL_REPRESENTATIVE_PROOF}
    field="legalRepresentativeProof"
  />
);

export default LegalRepresentativeProof;
